import Auth from '@aws-amplify/auth'

import { http, notification } from '../../services/index'
import { apiPaths } from '../../config'
import { factorySetStateAction } from '../factory'

// Defined Device Constants to bind SAGA functions with Redux Dispatcher
const actions = {
  SET_STATE: 'user/SET_STATE',
  LOGIN: 'user/LOGIN',
  LOAD_CURRENT_ACCOUNT: 'user/LOAD_CURRENT_ACCOUNT',
  LOGOUT: 'user/LOGOUT',
  FORGETPASSWORD_SEND_CODE: 'user/FORGETPASSWORD_SEND_CODE',
  FORGOTPASSWORD_SUBMIT: 'user/FORGOTPASSWORD_SUBMIT',
  EMAIL_VERIFY_SEND_CODE: 'user/EMAIL_VERIFY_SEND_CODE',
  EMAIL_VERIFY_SUBMIT: 'user/EMAIL_VERIFY_SUBMIT',
  INVITE_NEW_MEMBER: 'user/INVITE_NEW_MEMBER',
  ASSIGN_MEMBER_TO_PROVIDER: 'user/ASSIGN_MEMBER_TO_PROVIDER',
  SHARE_MEMBER: 'user/SHARE_MEMBER',
  GET_LINKED_PROVIDERS: 'user/GET_LINKED_PROVIDERS',
  UNLINK_PROVIDER: 'user/UNLINK_PROVIDER',
  REVOKE_PROVIDER: 'user/REVOKE_PROVIDER',
  EDIT_SLEEP_SESSION: 'user/EDIT_SLEEP_SESSION',
  VERIFICATION: 'user/VERIFICATION',
}

export const userSetState = factorySetStateAction(actions.SET_STATE)

export const forgotPasswordSendCode = (username) =>
  Auth.forgotPassword(username)
    .then((data) => ({ status: 200, data }))
    .catch((err) => ({ status: 403, err }))

export const forgotPasswordSubmit = (username, code, newPassword) =>
  Auth.forgotPasswordSubmit(username, code, newPassword)
    .then((data) => ({ status: 200, data }))
    .catch((err) => ({ status: 403, err }))

export const verifyAttributeEmailCode = (attr) =>
  Auth.verifyCurrentUserAttribute(attr)
    .then((data) => ({ status: 200, data }))
    .catch((err) => ({ status: 403, err }))

export const verifyEmail = (attributes, code) =>
  Auth.verifyCurrentUserAttributeSubmit(attributes, code)
    .then((data) => ({ status: 200, data }))
    .catch((err) => ({ status: 403, err }))

// API call to Share Member
export const shareMember = (dataObj, role) =>
  http
    .post(apiPaths[role].apiShareMember, dataObj, {})
    .then((res) => {
      notification.success('Success.', 'Member shared successfully')

      return res
    })
    .catch((err) => {
      const { response } = err
      notification.error(
        `Something went wrong`,
        `${response && response.data ? response.data : err}`,
      )
      return ''
    })

export const sleepSessionCreate = (role, dataObj) =>
  http
    .post(apiPaths[role].apiSessionCreate, dataObj, {})
    .then((res) => res)
    .catch((err) => {
      const { response } = err
      notification.warning(
        'Error creating sleep session',
        `${response ? response.data : 'Something went wrong'}`,
      )
      window.log('SleepSessionCreate error: ', err, response, err.code)
      return err
    })

// API call to Assign a Member to a Provider as a Super Admin
export const assignMemberToProvider = (dataObj, role) =>
  http
    .post(apiPaths[role].apiAssignMemberToProvider, dataObj, {})
    .then((res) => {
      notification.success('Success.', 'Member assigned to Provider')

      return res
    })
    .catch((err) => {
      const { response } = err
      notification.error(
        `Something went wrong`,
        `${response && response.data ? response.data : err}`,
      )
      return ''
    })

// API call to Revoke a Provider from a Member as a Super Admin
export const revokeProvider = (dataObj, role) =>
  http
    .post(apiPaths[role].apiRevokeProvider, dataObj, {})
    .then((res) => {
      notification.success('Success.', 'Provider Revoked')

      return res
    })
    .catch((err) => {
      const { response } = err
      notification.error(
        `Something went wrong`,
        `${response && response.data ? response.data : err}`,
      )
      return ''
    })

export const getLinkedProviders = (dataObj, role) =>
  http
    .get(apiPaths[role].apiLinkedProvidersListing, dataObj, {})
    .then((res) => res)
    .catch((err) => {
      const { response } = err

      notification.warning(
        'Something went wrong.',
        `${response && response.data ? response.data : err}`,
      )
    })

export const unlinkProvider = (dataObj, role) =>
  http
    .post(apiPaths[role].apiUnlinkProvider, dataObj, {})
    .then((res) => res)
    .catch((err) => {
      const { response } = err

      notification.warning(
        'Something went wrong.',
        `${response && response.data ? response.data : err}`,
      )
    })

export const inviteMember = (dataObj, role) =>
  http
    .post(apiPaths[role].apiInviteMember, dataObj, {})
    .then((res) => {
      notification.success('Success.', 'Invitation Sent')

      return res
    })
    .catch((err) => {
      const { response } = err

      notification.warning(
        'Something went wrong.',
        `${response && response.data ? response.data : err}`,
      )
    })

export const firstTimeLogin = () =>
  http
    .post(`/user-agreement/userAgreement`, {}, {})
    .then((res) => res)
    .catch((err) => {
      window.log('First Time Login', err)
      return []
    })

export const getUserClinicsList = ({ userId }, role) =>
  http
    .get(apiPaths[role].apiClinics.replace('{user_id}', userId), {}, {})
    .then((res) => res)
    .catch((err) => {
      const { response } = err

      notification.warning(
        'Something went wrong.',
        `${response && response.data ? response.data : err}`,
      )
    })

export const userVerificationAction = (payload) => ({
  type: actions.VERIFICATION,
  payload,
})

export default actions
